/**
 * Generates a tracking label for phone number interactions.
 *
 * @param isDealerListing - Indicates whether the listing is a dealer listing.
 * @param eventLocation - The location of the event. This determines where the click originated from:
 * - `top`: User click comes from the sticky sidebar.
 * - `bottom`: User click comes from the seller profile.
 * - `sticky`: User click comes from the sticky bottom bar.
 * @returns A formatted tracking label combining the dealer listing status and event location.
 */
export const generateVIPPhoneTrackingLabel = (
  isDealerListing: boolean,
  eventLocation: 'bottom' | 'top' | 'sticky'
): string => {
  return `isDealerListing=${isDealerListing};event_loc=${eventLocation}`
}
